var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChargerPinPrivate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 39,
    viewBox: "0 0 26 39",
    width: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13 38.863842c8.6666667-12.4560935 13-21.0773742 13-25.863842 0-7.17970175-5.8202983-13-13-13-7.17970175 0-13 5.82029825-13 13 0 4.7864678 4.33333333 13.4077485 13 25.863842z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    fill: "#fff",
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.94423326 12.4444444.49156793-1.1338271c1.47483658-.364484 3.07565035-1.63962471 3.07565035-3.15674076v-4.01665185h-1.63321814v-3.4608c0-.37360987-.31853868-.67642469-.7113947-.67642469-.3926058 0-.71114448.30281482-.71114448.67642469v3.4608h-2.84420256v-3.4608c0-.37360987-.31853867-.67642469-.71126958-.67642469-.39273092 0-.71114448.30281482-.71114448.67642469v3.4608h-1.52290584v4.01665185c0 1.53287902 1.44596111 2.81825186 2.94419388 3.16738766l.26774265 1.1231802h.64179849v3.5555556h.3242045.46545724v-3.5555556z",
    fill: "#666",
    fillRule: "nonzero",
    transform: "translate(8 7)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargerPinPrivate);
export default __webpack_public_path__ + "static/media/charger-pin-private.fa065349f398c21b9181daef6639ca31.svg";
export { ForwardRef as ReactComponent };